import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PackingBySystemContainer from '../containers/PackingBySystemContainer.jsx';

import DropDownInput from './common/DropDownInput.jsx';

export default class PackingComponent extends React.Component {

  componentDidMount() {
    this.props.findAllOrderIds();
  }

  render() {
    return (
      <div>
        <h4>裝箱管理</h4>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={6} sm={3} md={3}>
            <DropDownInput id="orderId"
              label="訂單編號"
              options={this.props.allOrderIds.map((value, key) => ({ label: value, value: value })).toJS()}
              selected={[{ label: this.props.orderId, value: this.props.orderId }]}
              onChange={(id, value, label) => {
                this.props.clearPackingAlert();
                this.props.changeOrderId({ orderId: value });
                this.props.findPackingItemList({ orderId: value });
                this.props.findDistinctCategories({ orderId: value });
                this.props.findPackingBoxNumbers({ orderId: value });
                this.props.findUnPackingItemCount({ orderId: value });
              }}
            />
          </Col>
          <Col xs={6} sm={9} md={9}>
            {this.props.unPackingItemMessage}
          </Col>
        </Row>
        <PackingBySystemContainer />
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/PackingComponent.jsx